import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { MESSAGING_SERVICE } from 'core/constants/endpoints'
import store from 'utils/store/withMiddleware'
import getAgentAuthorizationToken from 'utils/pivot/agent/getAgentAuthorizationToken'
import handleEmailResponse from 'core/controllerPlansFixed/saveThisQuoteConfig/handleEmailResponse'

function sendEmailFromAgent({ config, data }) {
  const { hcStorage } = store.getState()
  const timestamp = Date.now()
  hcStorage.healthcareSession = `${hcStorage.healthcareSession}-${timestamp}`
  hcStorage.healthcareUserId = `${hcStorage.healthcareUserId}-${timestamp}`

  return Promise.all([
    fetchJSONHandleError({
      url: `${MESSAGING_SERVICE}/SendMessage`,
      data,
      config: {
        headers: {
          Authorization: `Bearer ${getAgentAuthorizationToken()}`,
          'Content-Type': 'application/json'
        }
      }
    })
  ]).then(handleEmailResponse)
}

export default sendEmailFromAgent
